import React, { PropsWithChildren } from "react";
import { ScrollView, ScrollViewProps } from "react-native";

import { css } from "style";

export default function ListContainer(
  props: PropsWithChildren<ScrollViewProps>
) {
  return (
    <ScrollView
      keyboardShouldPersistTaps="always"
      showsVerticalScrollIndicator={false}
      {...props}
      contentContainerStyle={{
        ...css.paddingH,
        ...css.growContainer,
        paddingVertical: 10,
        ...(props.contentContainerStyle as object),
      }}
    >
      {props.children}
    </ScrollView>
  );
}
